//------------------------------------------------------------------------
// Bubble animations (only shown in desktop view when hero is visible)
//-----------------------------------------------------------------------
import anime from 'animejs/lib/anime.es.js';

export default class BubbleAnimations {
  constructor() {
    // Exit early if user has “prefers-reduced-motion” enabled
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return false;
    }

    // Placeholder for anime instances (one per bubble)
    this.animations = [];

    // Get breakpoint from CSS var
    this.mobileNavBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--layout-nav-bp');
    this.mediaQueryList = window.matchMedia(`(min-width: ${this.mobileNavBreakpoint})`);

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.init();
      } else {
        this.destroy();
      }
    });

    // Init on load
    if (this.mediaQueryList.matches) {
      this.init();
    }
  }

  init() {
    // Store animation state
    this.isPlaying = true;

    // https://animejs.com/documentation/#duration
    const config = {
      autoplay: true,
      direction: 'alternate',
      duration: 10000,
      easing: 'easeInOutQuad',// https://easings.net/
      loop: true,
    };

    // We need to store the final state of each bubble
    // NOTE: Start and end bubbles paths much have the _same number of points_ for anime to work.
    const bubbleData = [
      {
        d: [{
          value: 'M78 420C48.5 447 75.5 471.516 88.5 477C120.5 490.5 127.5 533 175 513C198.171 498.522 204.663 457.667 190.5 435C176.337 412.332 119.692 381.841 78 420Z'
        }],
        delay: 0,
      },
      {
        d: [{
          value: 'M189 218.501C202.324 216.951 217.675 225.057 226.087 207.279C234.5 189.501 224.757 161.068 212.5 155.502C192.885 146.594 149.843 157.623 149.843 193.788C149.843 218.501 160.107 221.862 189 218.501Z'
        }],
        delay: 3000,
      },
      {
        d: [{
          value: 'M230 116C212.692 140.523 174 139.999 148.5 113.499C122.496 86.4749 140.294 63.705 151 52.9987C172.063 31.9358 197.529 61.5277 213 76.9987C228.471 92.4697 236 107.499 230 116Z'
        }],
        delay: 700,
      },
      {
        d: [{
          value: 'M634.509 120.5C634.509 139.554 600.42 173 579.991 173C559.561 173 532 158 538 125C544 92 586.071 80 606.5 80C626.929 80 634.509 101.446 634.509 120.5Z'
        }],
        delay: 2000,
        duration: 12000,
      },
      {
        d: [{
          value: 'M614 620.001C630.576 616.112 654.312 632.148 658.5 649.999C662.688 667.851 656 702 626 706.999C609.424 710.888 596.188 677.352 592 659.5C587.812 641.649 597.424 623.89 614 620.001Z'
        }],
        delay: 1000,
      },
      {
        d: [{
          value: 'M406 516.5C373.724 542.5 379.5 572.5 390.627 591.992C401.754 611.484 443.5 605.742 471 591.992C501 576.992 502.504 544.333 485.5 529.001C455 501.5 424 502 406 516.5Z'
        }],
        delay: 4000,
      }
    ];

    // Init anime on each bubble
    bubbleData.forEach((item, index) => {
      let bubble = anime({
        targets: '#bubble-' + (index + 1),
        d: item.d,
        delay: item.delay,
        autoplay: config.autoplay,
        direction: config.direction,
        duration: item.duration || config.duration,
        easing: config.easing,
        loop: config.loop,
      });

      this.animations.push(bubble);
    });

    // Pause the animations when the hero image has scorlled out of the viewport
    this.heroObserver = new IntersectionObserver((entries) => {
      let entry = entries[0];
      if (!entry.isIntersecting) {
        this.pause();
      } else if (!this.isPlaying) {
        this.play();
      }
    },
    {
      rootMargin: '0px',
      threshold: [0]
    });
    this.heroObserver.observe(document.querySelector('.Hero-image'));
  }

  play() {
    this.animations.forEach(animation => animation.play());
    this.isPlaying = true;
  }

  pause() {
    this.animations.forEach(animation => animation.pause());
    this.isPlaying = false;
  }

  destroy() {
    this.pause();
    this.heroObserver.disconnect();
  }
}
